var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading || _vm.globalLoading),expression:"loading || globalLoading"}],staticClass:"index",style:({
		height: _vm.pageHeight
	})},[(_vm.inited)?_c('Parser',{attrs:{"canvasStyleOut":_vm.canvasStyle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }